import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';

const TermsCondition: React.FC = () => {
  return (
    <Box m={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Grid item container spacing={3}>
            <Grid item xs={12}>
              <Box
                p={2}
                sx={{
                  backgroundColor: 'white',
                }}
                borderRadius={2}
              >
                {/* Terms of Service */}
                <Typography variant="h5" mt={2}>
                  Terms of Service
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Thanks for using Virtuals Protocol!
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We drafted the following Terms of Service to make your user
                  experience as smooth, private and secure as possible. We are
                  very much open to feedback - contact us at hello@virtuals.io
                  with any question or concern!
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Please read these Terms carefully as they contain important
                  information about what we do and do not offer, and what you
                  can and cannot do.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Whenever you want to use or purchase the Services that we
                  provide at{' '}
                  <a href="https://app.virtuals.io">https://app.virtuals.io</a>{' '}
                  and related sites (the "Website"), these Terms of Service,
                  together with our Supplemental Terms, notices and policies
                  available at{' '}
                  <a href="https://app.virtuals.io">https://app.virtuals.io</a>{' '}
                  , and/or any other binding document that we provide and/or
                  that you sign (the “Terms” or the “Agreement”) will apply to
                  you.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  In other words, these Terms are a binding agreement between
                  us, Virtuals Studio Limited, a BVI corporation ("Virtual
                  Protocol", "Company", "us", "we"), and You, whether you are a
                  user ("User", "You") or a customer ("Customer", "you"). You
                  should also carefully review all of our other policies
                  available on our Website, including our Privacy Policy.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  By accessing, using or purchasing the Services, you consent to
                  all of these Terms and policies. So, if you do not agree with
                  any of those, please do not access, use or purchase the
                  Services.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We may change or update the Terms from time to time. Changes
                  will be effective 10 days following posting on the Website. If
                  you continue using the Services 10 days following such
                  posting, that means you accept those changes.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We may also post and update supplemental terms for specific
                  Services ("Supplemental Terms"), and such Supplemental Terms
                  will also apply to you.
                </Typography>

                {/* Definitions */}
                <Typography variant="h5" mt={2}>
                  Definitions
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Account" is the account that you, or your entity, will create
                  on the Website to access, use or purchase our Services. It
                  must be secured by a strong password!
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Agreement" or "Terms" refer to all of the terms and
                  conditions that apply between us. They include these Terms,
                  Supplemental Terms, notices and policies available at{' '}
                  <a href="https://app.virtuals.io">https://app.virtuals.io</a>{' '}
                  , and/or any other binding document that we provide and/or
                  that you sign, including but not limited to an Order Form, a
                  Scope of Work or a Master Services Agreement.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Inference API" refers to hosted services available on{' '}
                  <a href="https://app.virtuals.io">https://app.virtuals.io</a>{' '}
                  that let you, individuals, companies or organizations, run
                  inference via application programming interface on machine
                  learning models publicly or privately hosted on Virtual
                  Protocol's model hub.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Content" refers to any material posted, displayed, or
                  accessed on our Website or Hub, including but not limited to
                  code, data, text, graphics, images, applications, or software
                  you, we, or any third party provide or make available.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Dataset" refers to a structured collection of data samples
                  used to train machine learning Models.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Effective Date" refers to the last date of signature of the
                  Agreement, or any other binding document.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Inference Endpoint Service" refers to the Virtuals Protocol
                  Hub service through which the Customer can create, edit,
                  manage and delete Managed Endpoints.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Virtuals Protocol" refers to Virtuals Protocol Inc., which
                  may perform its obligations through its affiliates, directors,
                  subsidiaries, contractors, licensors, officers, agents and/or
                  employees.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Virtuals Protocol Open-Source Libraries" refers to the
                  Virtual Protocol open-source software projects available at{' '}
                  <a href="https://app.virtuals.io">https://app.virtuals.io</a>,
                  including Transformers, Datasets and Tokenizers.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Model" refers to a pre-trained machine learning model
                  including algorithms and weights, which can be run to make
                  predictions.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Organization" refers to a workspace representing a legal
                  entity and/or several Users. A User can be part of multiple
                  organizations.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Repository" refers to a data structure which contains all of
                  the project files and the entire revision history. A
                  Repository may be public (i.e. anyone on the internet can see
                  it, but only you or members of your organization can make
                  changes) or private (i.e. only you or members of your
                  organization can see and make changes to the repository).
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "Services" refer to the products and/or services we offer or
                  provide, and that you access, use or purchase. Services may
                  include limited licenses or subscriptions to access or use
                  certain offerings in accordance with these Terms, including
                  use of Models, Datasets, Virtuals Protocol Open-Sources
                  Libraries, the Inference API, AutoTrain, Expert Acceleration
                  Program, Infinity or other Content. Reference to "purchases"
                  and/or "sales" mean a limited right to access and use a
                  Service (not a transfer or any ownership right, title, or
                  interest) in accordance with these Terms.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  "User" refers to the individual person, company or
                  organization that accesses, receives, or uses the Services.
                  That's you!
                </Typography>

                {/* Your Use of the Services */}
                <Typography variant="h5" mt={2}>
                  Your Use of the Services
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  You must use our Services in strict compliance with these
                  Terms, the Supplemental Terms for each Service, all of our
                  policies available on our Website, and all applicable laws or
                  regulations in the relevant jurisdiction(s).
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We may at any time modify, suspend, or discontinue,
                  temporarily or permanently, the Services (or any part thereof)
                  with or without notice. You agree that we will not be liable
                  to you or to any third party for any modification, suspension
                  or discontinuance of the Services.
                </Typography>

                {/* Your Account */}
                <Typography variant="h5" mt={2}>
                  Your Account
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Pretty basic, but necessary before accessing some of our
                  Services!
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  In order to create an Account for yourself or for your
                  Organization on our Website, you must be a natural person of
                  at least age 13, or a legal entity duly registered. If you
                  decide to create an Account for your Organization, you
                  represent that you have the authority to act on behalf of your
                  Organization and bind your Organization to these Terms.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  When you create your Account, we are going to ask you to
                  provide us with some basic information, such as your email
                  address password, username, full name, and other optional
                  information such as an avatar, your interests, usernames to
                  your third-party social networks, or payment information if
                  you decide to purchase one of our paid Services. All
                  information must be accurate and valid.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  🔒Security is very important to us, and we need every member
                  of our community to cooperate. You are responsible for
                  maintaining the confidentiality and security of your password
                  necessary for accessing your Account and the Services. You may
                  not disclose your password to any third party, and you are
                  solely responsible for any action taken with your Account. You
                  must notify us immediately of any actual or suspected breach
                  of security on your Account, loss or compromise of password,
                  or unauthorized use of your Account.
                </Typography>

                {/* Your Content */}
                <Typography variant="h5" mt={2}>
                  Your Content
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  You are solely responsible for the Content you post, publish,
                  display or otherwise make available on our Website, and for
                  any other action or omission that results from your use of the
                  Services (including our Content or other user's Content), or
                  the use by a person or an entity that you have authorized
                  under your Account.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  You represent and warrant that you have ownership, control,
                  and responsibility for the Content you post or otherwise make
                  available on our Website, or otherwise have the right to do
                  so. Your Content must not be misleading or unlawful, and must
                  not violate any of these Terms, applicable law and regulation,
                  or infringe or misappropriate any rights of any person or
                  entity. We may remove your Content at any time, at our sole
                  discretion, if we have a concern about your Content.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  You own the Content you create! We will not sell your Content,
                  nor will we use it in any other way as permitted under these
                  Terms. However, by posting your Content or otherwise making it
                  available on our Website, you must be aware that:
                </Typography>
                <List sx={{ listStyle: 'decimal', mx: 2 }}>
                  <ListItem sx={{ display: 'list-item' }}>
                    <ListItemText primary="You hereby grant us a worldwide, royalty-free and non-exclusive license to use, display, publish, reproduce, distribute, and make derivative works of such Content to provide Services and as otherwise permitted under these Terms and our Privacy Policy; and, Your Content will be viewed by others, and therefore:" />
                    <List sx={{ listStyle: 'lower-alpha', mx: 2 }}>
                      <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="You grant each User a perpetual, irrevocable, worldwide, royalty-free, non-exclusive license to use, display, publish, reproduce, distribute, and make derivative works of your Content through our Services and functionalities;" />
                      </ListItem>
                    </List>
                  </ListItem>
                </List>
                <Typography sx={{ mt: 2 }}>
                  When Content contains notice of a reasonable and customary
                  license, (such as an open source license) such Content is
                  intended to remain under the terms of such license when
                  further accessed, distributed, or used. Neither party is
                  permitted to remove reference to any such license.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Any Content you download, access or use from us or another
                  User, is at your own risk and subject to these Terms and/or
                  the terms accompanying such Content.
                </Typography>

                {/* Termination */}
                <Typography variant="h5" mt={2}>
                  Termination
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  You may decide to cancel your Account whenever you want, at
                  your sole discretion.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We may do the same, and we reserve the right to suspend or
                  terminate your access to the Services anytime with or without
                  cause, and at our own discretion, with or without notice.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Upon cancellation of your Account, we will use commercially
                  reasonable efforts to delete your information and Content of
                  your own Repositories, whether public or private, within 90
                  days. We will not delete the Content that you contributed to
                  other Users' Repositories, or copies made by us or other
                  Users.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We also reserve the right to retain your information for legal
                  or regulatory compliance, pursuant to standard archiving,
                  recovery, and back-up processes and practices, and pursuant to
                  our Privacy Policy.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  For certain Services, the Service Term and causes for
                  termination may be specified in the Supplemental Terms and/or
                  in any other binding document signed between us, including but
                  not limited to an Order Form, a Scope of Work, or a Master
                  Service Agreement, which are fully incorporated into the
                  Agreement between us.
                </Typography>

                {/* Intellectual Property */}
                <Typography variant="h5" mt={2}>
                  Intellectual Property
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Let's give credit where it is due, and protect our
                  intellectual property rights!
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Proprietary Rights. We retain ownership of all of our
                  intellectual property rights related to the Website and the
                  Services, including all improvements to the Services. All
                  materials that we produce, including the Website, design,
                  code, graphics, interfaces, trademarks, and logo shall remain
                  our exclusive property. You may not alter, reproduce,
                  republish, license any of our proprietary materials, unless we
                  expressly give you a written permission to do so. All rights
                  not expressly granted are reserved and retained by us.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Nothing in these Terms is intended to limit our use of our
                  knowledge, skills, experience, ideas, concepts, know-how
                  and/or techniques developed or learned at any time, without
                  limitation. If you provide us feedback regarding the use,
                  operation, performance, or functionality of our Website,
                  Services, or business (collectively, "Feedback"), you hereby
                  grant us a perpetual, irrevocable, worldwide, royalty-free,
                  and non-exclusive right and license to exploit and
                  commercialize the Feedback, improve the Services, and develop
                  and/or commercialize new offerings, which we will solely and
                  exclusively own. In addition and subject to our Privacy
                  Policy, we may aggregate, anonymize, or otherwise learn from
                  data relating to your use of the Services, and use the
                  foregoing to improve those Services.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Supplemental Terms. Certain Services may be governed by
                  specific intellectual property terms which are stated in the
                  Supplemental Terms and/or in any other binding document signed
                  between us, and which are fully incorporated into the
                  Agreement between us.
                </Typography>

                {/* Privacy */}
                <Typography variant="h5" mt={2}>
                  Privacy
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Your privacy is paramount to us, and here is how we respect
                  it.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We will provide the Services in accordance with our Privacy
                  Policy available at:{' '}
                  <a href="https://app.virtuals.io/privacy ">
                    https://app.virtuals.io/privacy{' '}
                  </a>
                  .
                </Typography>

                {/* Liability */}
                <Typography variant="h5" mt={2}>
                  Liability
                </Typography>
                <Typography sx={{ mt: 2 }}>Our worst case scenario.</Typography>
                <Typography sx={{ mt: 2 }}>
                  Neither of us (or any of our affiliates, subsidiaries,
                  contractors, licensors, officers, directors, agents, or
                  employees ("Related Parties")) will be liable for any
                  indirect, incidental, consequential, punitive, special, or
                  other similar damages, including loss of revenue, profits,
                  data, benefits, or savings, whether or not due to the fault or
                  negligence of the company or related parties, and regardless
                  of whether either of us or our related parties have been
                  advised of the possibility of such damages or losses.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Either Party’s (and each Related Party’s) aggregate liability
                  to the other Party or any third party in any circumstance will
                  not exceed the amount that you paid us during the 12-month
                  period immediately preceding the last claim (or $50 if
                  relating to a free service). This limitation will not apply to
                  (i) either party’s liability from fraud, gross negligence,
                  recklessness, or willful or criminal misconduct, (ii) your
                  liability for infringement of our intellectual property
                  rights, (iii) your liability for breach of the confidentiality
                  section, or (iv) amounts you owe us for the service made
                  available as per your payment obligations.
                </Typography>

                {/* Indemnity */}
                <Typography variant="h5" mt={2}>
                  Indemnity
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  In this regard, you agree to indemnify, defend and hold
                  harmless us and Related Parties from all claims, liability,
                  and expenses, including attorney's fees, arising out or in
                  connection with your use of (or inability to use) the
                  Services, including but not limited to your violation of these
                  Terms, applicable law or regulation, any Content or data
                  posted or used by you, or any other party's use of any Service
                  with your credentials, unless arising directly from Virtual
                  Protocol’s fraud, gross negligence, recklessness, or willful
                  or criminal misconduct, provided that we provide you with (i)
                  a prompt written notice of the claim, demand, suit or
                  proceeding, (ii) sole control of the defense and settlement of
                  the claim, demand, suit or proceeding, and (iii) all
                  reasonable assistance and cooperation in connection with the
                  defense and settlement of the claim, at its own expense.
                </Typography>

                {/* Disclaimer of Warranties */}
                <Typography variant="h5" mt={2}>
                  Disclaimer of Warranties
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  There are certain promises that we cannot make...
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We provide Services that you may or may not decide to access,
                  use or purchase. In this regard, we make no warranties or
                  representations about these Services.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  In other words, except as expressly provided otherwise herein,
                  and to the fullest extent permitted by law, the Services and
                  Content are provided "as is" and "as available".
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We disclaim all warranties or guarantees of any kind, express
                  or implied, whether arising under any law or from any usage in
                  trade, or otherwise, including but not limited to the implied
                  warranties of merchantability, non-infringement, quiet
                  enjoyment, fitness for a particular purpose, or otherwise.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We further disclaim all warranties or guarantees about the
                  accuracy, reliability or benefits of any Services, artificial
                  intelligence, Models or any other technology or Content, or
                  that the Services or Content will meet your requirements, be
                  secure, uninterrupted or available at any time or location, or
                  error-free, viruses-free, or that any errors will be
                  corrected, or otherwise.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  You will be solely responsible for any damage resulting from
                  your use of or access to the Services, your downloading of
                  Content or data, or use of any other material provided by or
                  through the Services.
                </Typography>

                {/* Misc */}
                <Typography variant="h5" mt={2}>
                  Miscellaneous
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  We reserve the right to update or modify these Terms at any
                  time without prior notice. Any changes will be effective
                  immediately upon posting the updated Terms on this Site. Your
                  continued use of the Site after the changes will constitute
                  your acceptance of the revised Terms.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  No Waiver. The failure, in one or more instances, to perform
                  any of the terms or conditions of these Terms, or to exercise
                  any right hereunder, shall not be construed as a waiver of the
                  future performance of any such terms or conditions, or the
                  future exercise of such right, and the obligations of under
                  these Terms with respect to such performance shall continue in
                  full force and effect.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Survival. The termination or expiration of these Terms shall
                  not relieve from any obligation (i) that may have arisen prior
                  to such termination or expiration, or (ii) that needs to
                  survive termination or expiration in order to give full effect
                  to its meaning, including without limitation payment
                  obligations, confidentiality obligations, limitation of
                  liability, warranty disclaimers, indemnities, governing law
                  and dispute resolution, miscellaneous, and definitions.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Execution. Each Party represents and warrants that (i) it
                  possesses the legal right and capacity to enter into, execute,
                  deliver and perform the Agreement; (ii) the individual signing
                  the Agreement on the Party’s behalf has full power and
                  authority to bind the Party to the terms and conditions set
                  out in this Agreement; and (iii) the Agreement is a valid and
                  binding obligation of that Party. You agree that an electronic
                  signature shall have the same force and effect as manual
                  signatures.
                </Typography>

                {/* Contact Us */}
                <Typography variant="h5" mt={2}>
                  CONTACT US
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  If you have any questions or concerns about these Terms or our
                  Site, please contact us at{' '}
                  <a href="mailto:hello@virtuals.io">hello@virtuals.io</a>.
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  This website is developed by Path Systems Sdn. Bhd.
                  (1443810-P).
                </Typography>
                <Typography sx={{ mt: 2 }}>© Virtuals Protocol</Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default TermsCondition;
